import { deleteRecordsByRelationId } from ":shared/database/delete";
import type { DeckIdentifiable } from "../model";
import { TABLE } from "./shared";

export async function deleteRecordsById({
	id,
	options,
}: Pick<Parameters<typeof deleteRecordsByRelationId>[0], "id" | "options">) {
	return deleteRecordsByRelationId<DeckIdentifiable, "id">({
		key: "id",
		id,
		options,
		table: TABLE,
	});
}
